import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'
import { SxProps } from '@mui/system'

export type IParrotfishIcon = Partial<Queries.PARROTFISHICONFragment> & { sx?: SxProps }
const ParrotfishIcon: React.FC<IParrotfishIcon> = ({ iconImage, color, width, height, sx }) => {
  const url = iconImage?.file?.url
  const type = iconImage?.file?.contentType

  const styles = {
    mask: `url('${url}') no-repeat center / contain`,
    WebkitMask: `url('${url}') no-repeat center / contain`,
    height: '43px',
    width: '43px',
  }

  return (
    <>
      {type === 'image/svg+xml' ? (
        <SvgIcon sx={{ ...styles, ...sx }} htmlColor={color || ''} viewBox={`0 0 ${width || 48} ${height || 48}`}>
          <rect width="100%" height="100%" />
        </SvgIcon>
      ) : (
        <></>
      )}
    </>
  )
}

export default ParrotfishIcon
